import { simpleLookupConfig } from "../../../shared/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineModel";

const url = "/api/machines/MachineModel";

export const machineModelLookupConfig = simpleLookupConfig({
  name: vsObjectName,
  nameSingular: "Model",
  url,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
});
